import React from "react";
import { Rnd } from "react-rnd";
import { Player } from "./components/Player";
import { createPortal } from "react-dom";

const style = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "solid 1px #ddd",
    background: "#f0f0f0",
} as const;

export function VideoPlayer({ context }: any) {
    const left = true;
    const expanded = context.state.video;

    return createPortal(
        <Rnd
            className="x_sub_player0_container"
            style={{ ...style, zIndex: expanded ? 1000 : -1 }}
            cancel=".x_button, .x_player_video_set_1"
            default={{
                x: 50,
                y: 200,
                width: 400,
                height: 250,
            }}
        >
            <div
                className={`x_sub_player0 ${expanded ? "" : "x_sub_player0--collapsed"} ${left ? "" : "x_sub_player0--right"}`}
            >
                <div className="x_sub_player_h">
                    <div className="p_b_title">
                        <div className="ico">
                            <div>videocam</div>
                        </div>
                        <div>Video</div>
                    </div>
                    <div className="x_sub_player_right">
                        {/*expanded && <TooltipH title={`Переместить ${left ? 'вправо' : 'влево'}`}>
              <div className="x_button x_button--ghost"
                onClick={() => setLeft(prev => !prev)}
              >
                <div className="t_icon">
                  {left ? 'arrow_forward' : 'arrow_back'}
                </div>
              </div>
            </TooltipH>*/}

                        {expanded && (
                            <button
                                style={{ cursor: "pointer" }}
                                className="x_button x_button--ghost"
                                onClick={() => context.handles.setVideo()}
                            >
                                <div>Hide</div>
                            </button>
                        )}

                        {!expanded && (
                            <div
                                className="x_button x_button--ghost"
                                onClick={() => context.handles.setVideo("sm")}
                            >
                                <div>Expand</div>
                            </div>
                        )}
                    </div>
                </div>

                <div className="x_sub_player _fv _fcc">
                    <Player />
                </div>
            </div>
        </Rnd>,
        document.body,
    );
}
